import React, { useState, useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { trackPageView } from '../util/Analytics.jsx';
import Utils from '../util/Utils.jsx';

import { useStateValue } from '../context/state.jsx';
import { setTokenExpired } from '../context/token.js';
import { setLoginSucceeded } from '../context/loginSucceeded.js';
import { setMustChangePassword } from '../context/mustChangePassword.js';

const InvitePage = () => {
	const [message, setMessage] = useState('');
	const [redirectTo, setRedirectTo] = useState(null);
	const [, dispatch] = useStateValue();
	const { Token } = useParams();

	useEffect(() => {
		trackPageView();

		if (Token) {
			setMessage('Opening your project...');
			Utils.ajax('acceptInvite', { Token }, dispatch, result => {
				if (result.success) {
					Utils.allowAuth();
					localStorage.setItem('token', result.Token);
					dispatch(setTokenExpired(false));
					dispatch(setLoginSucceeded(true));
					dispatch(setMustChangePassword(Boolean(result.mustChangePassword)));
					if (result.datasetId) {
						setRedirectTo(`/app/dataset/${result.datasetId}`);
					} else {
						setRedirectTo('/app/');
					}
				} else {
					setMessage(result.error || 'This invitation link is invalid or has expired.');
				}
			});
		} else {
			setMessage('This invitation link is invalid or has expired.');
		}
	}, []);

	if (redirectTo) {
		return (<Navigate to={redirectTo} replace />);
	}

	return (
		<div className="verifyPage">
			<div className="pageContent">
				<div className="verifyMessage">
					<h2>
						{message}
						<div className="agreement">
							<Link className="underline blueLink" to="/signin/">Sign in to SiteWalker</Link>
						</div>
					</h2>
				</div>
			</div>
		</div>
	);
};

export default InvitePage;
